<template>
    <button class="contact-card" @click="$emit('show', contact)" ref="card" :class="{ show: show }">
        <div class="image" :style="`background-image: url('/files-large/${contact.large}');`" role='img' :alt="fullname"></div>
        <div class="details">
            <h3 v-text="fullname" />
            <div class="title" v-html="title" />
        </div>
    </button>
</template>

<script>
    export default {
        mounted() {
            window.addEventListener('keyup', event => {
                if(event.keyCode === 81) this.show = true;
            });
            window.addEventListener('scroll', this.scroll);
            this.scroll()
        },
        methods: {
            scroll(event) {
                if(this.$refs.card.getBoundingClientRect().top < window.innerHeight * 0.77) {
                    setTimeout(() => {
                        this.show = true;
                    }, this.$refs.card.getBoundingClientRect().left / 2);
                }
            }
        },
        props: {
            contact: {
                required: true,
                type: Object,
                default: {
                    first_name: 'first name',
                    last_name: 'last name'
                }
            }
        },
        computed: {
            fullname() {
                return this.$route.params.lang === 'hu'
                    ? `${this.contact.last_name} ${this.contact.first_name}`
                    : `${this.contact.first_name} ${this.contact.last_name}`;
            },
            title() {
                return this.contact['title_' + this.currentLanguage] || this.contact.title_en;
            }
        },
        data() {
            return {
                currentLanguage: window.currentLocale,
                show: false
            }
        }
    }
</script>

<style lang="scss" scoped>

    @import './../../sass/variables';

    pre {
        text-align: left;
        overflow: hidden;
        display: block;
        width: 400px;
    }

    .contact-card {
        background-color: transparent;
        transition: all 300ms;
        transform: scale(.5);
        position: relative;
        min-height: 300px;
        text-align: left;
        padding: 20px;
        opacity: 0;
        width: 25%;
        border: 0;

        @media screen and (max-width: $desktop-max) {
            width: calc(100% / 3);
        }

        @media screen and (max-width: $tablet-max) {
            min-height: 250px;
            width: 50%;
        }

        @media screen and (max-width: $mobile-max) {
            width: 50%;
        }

        &.show {
            transition: all 300ms;
            transform: scale(1);
            opacity: 1;
        }

        &:hover {
            transition: all 300ms;

            .image {
                transition: all 300ms;

                &:after {
                    transition: all 300ms;
                    opacity: 1;
                }
            }

            // &:before,
            // &:after {
            //  transform: translate(0,0);
            //  transition: all 300ms;
            //  opacity: 1;
            // }
        }

        .image {
            background-color: lighten(#000, 90%);
            background-position: center;
            background-size: cover;
            transition: all 300ms;
            position: relative;
            display: block;
            margin: 0 auto;
            height: 350px;
            width: 100%;
            z-index: 1;
            left: 0;
            top: 0;

            @media screen and (max-width: $tablet-max) {
                height: 250px;
            }

            &:after {
                background-color: rgba($light-blue, 0.3);
                color: rgba($light-blue,0.3);
                font-family: sans-serif;
                transition: all 300ms;
                text-align: center;
                line-height: 280px;
                position: absolute;
                font-weight: bold;
                font-size: 200px;
                display: block;
                bottom: 10px;
                content: '';
                right: 10px;
                opacity: 0;
                left: 10px;
                top: 10px;
            }

        }

        .details {
            position: absolute;
            padding: 40px;
            width: 100%;
            z-index: 3;
            bottom: 0;
            left: 0;

            &:after {
                background-image: linear-gradient(to bottom, rgba(0,0,0,0),rgba(0,0,0,0.2));
                height: calc(100% - 40px);
                width: calc(100% - 40px);
                position: absolute;
                display: block;
                bottom: 20px;
                content: '';
                z-index: 2;
                left: 20px;
            }

            @media screen and (max-width: $mobile-max) {
                padding: 30px;
            }
        }

        h3 {
            margin-bottom: 5px;
            position: relative;
            font-weight: bold;
            font-size: 20px;
            color: #fff;
            z-index: 3;

            @media screen and (max-width: $mobile-max) {
                font-size: 14px;
                margin-bottom: 1px;
            }
        }

        .title {
            white-space: pre-line;
            margin-bottom: 3px;
            position: relative;
            color: #fff;
            z-index: 3;

            @media screen and (max-width: $mobile-max) {
                font-size: 12px;
                margin-bottom: 1px;
            }
        }

        &.black {

            h3, p {
                color: #000;
            }

            .details {
                &:after {
                    display: none;
                }
            }
        }

        a {
            text-decoration: none;
            color: $black;

            &:hover {
                color: $light-blue;
            }

            .ion-social-linkedin {
                color: $linkedin;
            }
        }

    }

</style>
